module.exports = __webpack_public_path__ + "img/ghfw.6e53c54e.png";